import { render, staticRenderFns } from "./antiIndulged.vue?vue&type=template&id=5e9a0f67"
import script from "./antiIndulged.vue?vue&type=script&lang=js"
export * from "./antiIndulged.vue?vue&type=script&lang=js"
import style0 from "./antiIndulged.vue?vue&type=style&index=0&id=5e9a0f67&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports